import { CircularProgress } from "@mui/material";

const LoadingIndicator = ({ size = 16 }) => {
	return <CircularProgress className='loading-indicator' color='inherit' size={size} />;
};

export default LoadingIndicator;
